<template>
  <div class="reset-password-container">
    <form class="form" @submit.prevent="handleResetPassword">
      <!-- 欢迎标题 -->
      <div class="welcome-header">
        <h1 class="welcome-title">重置密码</h1>
        <p class="welcome-subtitle">请输入您的邮箱，我们将发送验证码</p>
      </div>

      <!-- 邮箱 -->
      <div class="input-wrapper">
        <div class="inputForm" :class="{ 'input-error': emailError && formData.email }">
          <svg height="20" viewBox="0 0 32 32" width="20" xmlns="http://www.w3.org/2000/svg">
            <g id="Layer_3" data-name="Layer 3">
              <path d="m30.853 13.87a15 15 0 0 0 -29.729 4.082 15.1 15.1 0 0 0 12.876 12.918 15.6 15.6 0 0 0 2.016.13 14.85 14.85 0 0 0 7.715-2.145 1 1 0 1 0 -1.031-1.711 13.007 13.007 0 1 1 5.458-6.529 2.149 2.149 0 0 1 -4.158-.759v-10.856a1 1 0 0 0 -2 0v1.726a8 8 0 1 0 .2 10.325 4.135 4.135 0 0 0 7.83.274 15.2 15.2 0 0 0 .823-7.455zm-14.853 8.13a6 6 0 1 1 6-6 6.006 6.006 0 0 1 -6 6z"></path>
            </g>
          </svg>
          <input
            type="email"
            class="input"
            placeholder=" "
            v-model="formData.email"
            @blur="validateField('email')"
            @input="validateField('email')"
            id="email"
          >
          <label for="email" class="floating-label">邮箱</label>
        </div>
        <div v-if="emailError && formData.email" class="field-error">{{ emailError }}</div>
      </div>

      <!-- 验证码 -->
      <div class="input-wrapper">
        <div class="inputForm" :class="{ 'input-error': codeError && formData.code }">
          <svg height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
          </svg>
          <input
            type="text"
            class="input code-with-button"
            placeholder=" "
            v-model="formData.code"
            @input="limitCodeLength"
            @blur="validateField('code')"
            maxlength="6"
            id="code"
          >
          <label for="code" class="floating-label">验证码（6位）</label>
          <button
            type="button"
            class="send-code-btn-inline"
            @click="handleSendCode"
            :disabled="sendingCode || countdown > 0"
          >
            {{ countdown > 0 ? `${countdown}秒后重发` : (sendingCode ? '发送中...' : '发送验证码') }}
          </button>
        </div>
        <div v-if="codeError && formData.code" class="field-error">{{ codeError }}</div>
      </div>

      <!-- 新密码 -->
      <div class="input-wrapper">
        <div class="inputForm" :class="{ 'input-error': passwordError && formData.password }">
          <svg height="20" viewBox="-64 0 512 512" width="20" xmlns="http://www.w3.org/2000/svg">
            <path d="m336 512h-288c-26.453125 0-48-21.523438-48-48v-224c0-26.476562 21.546875-48 48-48h288c26.453125 0 48 21.523438 48 48v224c0 26.476562-21.546875 48-48 48zm-288-288c-8.8125 0-16 7.167969-16 16v224c0 8.832031 7.1875 16 16 16h288c8.8125 0 16-7.167969 16-16v-224c0-8.832031-7.1875-16-16-16zm0 0"></path>
            <path d="m304 224c-8.832031 0-16-7.167969-16-16v-80c0-52.929688-43.070312-96-96-96s-96 43.070312-96 96v80c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-80c0-70.59375 57.40625-128 128-128s128 57.40625 128 128v80c0 8.832031-7.167969 16-16 16zm0 0"></path>
          </svg>
          <input
            :type="showPassword ? 'text' : 'password'"
            class="input"
            placeholder=" "
            v-model="formData.password"
            @blur="validateField('password')"
            @input="validateField('password')"
            id="password"
          >
          <label for="password" class="floating-label">新密码（至少6位）</label>
          <!-- 睁眼图标 - 密码隐藏时显示 -->
          <svg 
            v-if="!showPassword"
            class="eye-icon" 
            @click="togglePasswordVisibility"
            viewBox="0 0 576 512" 
            height="1em" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path>
          </svg>
          <!-- 闭眼图标 - 密码显示时显示 -->
          <svg 
            v-else
            class="eye-icon" 
            @click="togglePasswordVisibility"
            viewBox="0 0 640 512" 
            height="1em" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c8.4-19.3 10.6-41.4 4.8-63.3c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zM373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5L373 389.9z"></path>
          </svg>
        </div>
        <div v-if="passwordError && formData.password" class="field-error">{{ passwordError }}</div>
      </div>

      <button class="button-submit" type="submit" :disabled="loading">
        {{ loading ? '提交中...' : '重置密码' }}
      </button>

      <p class="p">
        <span class="span" @click="goToLogin">返回登录</span>
        <span style="margin: 0 10px;">|</span>
        <span class="span" @click="goToRegister">立即注册</span>
      </p>
    </form>
  </div>
</template>

<script>
import { ref, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { sendResetPasswordEmail, resetPassword } from '../api/auth'
import toast from '../utils/toast'

export default {
  name: 'ResetPasswordPage',
  setup() {
    const router = useRouter()
    
    const formData = ref({
      email: '',
      code: '',
      password: ''
    })

    const loading = ref(false)
    const sendingCode = ref(false)
    const countdown = ref(0)
    const showPassword = ref(false)
    
    // 实时验证错误信息
    const emailError = ref('')
    const codeError = ref('')
    const passwordError = ref('')

    let countdownTimer = null

    // 验证函数
    const validateEmail = (email) => {
      if (!email) return ''
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return '邮箱格式不正确'
      return ''
    }

    const validateCode = (code) => {
      if (!code) return ''
      if (code.length !== 6) return '验证码必须是6位'
      if (!/^\d{6}$/.test(code)) return '验证码必须是6位数字'
      return ''
    }

    const validatePassword = (password) => {
      if (!password) return ''
      if (password.length < 6) return '密码至少6位'
      return ''
    }

    // 实时验证字段
    const validateField = (field) => {
      switch (field) {
        case 'email':
          emailError.value = validateEmail(formData.value.email)
          break
        case 'code':
          codeError.value = validateCode(formData.value.code)
          break
        case 'password':
          passwordError.value = validatePassword(formData.value.password)
          break
      }
    }

    // 限制验证码长度为6位
    const limitCodeLength = () => {
      if (formData.value.code.length > 6) {
        formData.value.code = formData.value.code.slice(0, 6)
      }
      // 实时验证
      codeError.value = validateCode(formData.value.code)
    }

    // 发送验证码
    const handleSendCode = async () => {
      // 必须输入邮箱
      if (!formData.value.email) {
        toast.error('请先输入邮箱')
        return
      }

      // 验证邮箱格式
      emailError.value = validateEmail(formData.value.email)
      if (emailError.value) {
        toast.error(emailError.value || '请输入正确的邮箱')
        return
      }

      sendingCode.value = true

      try {
        const response = await sendResetPasswordEmail({
          email: formData.value.email
        })

        if (response.code === 1) {
          toast.success(response.msg || '验证码已发送，请查收邮件')
          countdown.value = 60
          countdownTimer = setInterval(() => {
            countdown.value--
            if (countdown.value <= 0) {
              clearInterval(countdownTimer)
            }
          }, 1000)
        } else if (response.code === 0 || response.code === -1) {
          toast.error(response.msg || '发送失败')
        } else {
          toast.error('发送失败')
        }
      } catch (error) {
        console.error('发送验证码错误:', error)
        if (error.response && error.response.data) {
          toast.error(error.response.data.msg || '发送失败，请稍后重试')
        } else {
          toast.error('网络错误，请检查网络连接')
        }
      } finally {
        sendingCode.value = false
      }
    }

    // 重置密码
    const handleResetPassword = async () => {
      // 验证所有字段
      validateField('email')
      validateField('code')
      validateField('password')

      // 检查是否有错误
      if (!formData.value.email) {
        toast.error('请输入邮箱')
        return
      }
      if (emailError.value) {
        toast.error(emailError.value)
        return
      }

      if (!formData.value.code) {
        toast.error('请输入验证码')
        return
      }
      if (codeError.value) {
        toast.error(codeError.value)
        return
      }

      if (!formData.value.password) {
        toast.error('请输入新密码')
        return
      }
      if (passwordError.value) {
        toast.error(passwordError.value)
        return
      }

      loading.value = true

      try {
        const response = await resetPassword({
          email: formData.value.email,
          emailCode: formData.value.code,
          password: formData.value.password
        })

        if (response.code === 1) {
          toast.success('密码重置成功')
          console.log('密码重置成功')
          
          // 1.5秒后跳转到登录页，并携带邮箱和新密码
          setTimeout(() => {
            router.push({
              path: '/login',
              query: {
                username: formData.value.email,
                password: formData.value.password,
                autoFill: 'true'
              }
            })
          }, 1500)
        } else if (response.code === 0 || response.code === -1) {
          toast.error(response.msg || '重置失败')
        } else {
          toast.error('重置失败')
        }
      } catch (error) {
        console.error('重置密码错误:', error)
        if (error.response && error.response.data) {
          toast.error(error.response.data.msg || '重置失败，请稍后重试')
        } else {
          toast.error('网络错误，请检查网络连接')
        }
      } finally {
        loading.value = false
      }
    }

    const togglePasswordVisibility = () => {
      showPassword.value = !showPassword.value
    }

    const goToLogin = () => {
      router.push('/login')
    }

    const goToRegister = () => {
      router.push('/register')
    }

    // 组件卸载时清除倒计时
    onUnmounted(() => {
      if (countdownTimer) {
        clearInterval(countdownTimer)
      }
    })

    return {
      formData,
      loading,
      sendingCode,
      countdown,
      showPassword,
      emailError,
      codeError,
      passwordError,
      validateField,
      limitCodeLength,
      togglePasswordVisibility,
      handleSendCode,
      handleResetPassword,
      goToLogin,
      goToRegister
    }
  }
}
</script>

<style scoped>
.reset-password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #ffffff;
}

.welcome-header {
  text-align: center;
  margin-bottom: 30px;
}

.welcome-title {
  font-size: 28px;
  font-weight: 700;
  color: #151717;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}

.welcome-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
  font-weight: 400;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #ffffff;
  padding: 30px;
  width: 450px;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.input-wrapper {
  margin-bottom: 5px;
}

.inputForm {
  border: 1.5px solid #ecedec;
  border-radius: 10px;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  transition: 0.2s ease-in-out;
  position: relative;
}

.input {
  margin-left: 10px;
  border-radius: 10px;
  border: none;
  width: 100%;
  height: 100%;
  padding-right: 10px;
}

.input:focus {
  outline: none;
}

/* 去除浏览器自动填充的蓝色阴影/背景 */
.input:-webkit-autofill,
.input:-webkit-autofill:hover,
.input:-webkit-autofill:focus,
.input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
  -webkit-text-fill-color: #151717 !important;
  box-shadow: 0 0 0 30px white inset !important;
  transition: background-color 5000s ease-in-out 0s;
}

.inputForm:focus-within {
  border: 1.5px solid #2d79f3;
}

/* 浮动标签样式 */
.floating-label {
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 14px;
  font-weight: 400;
  pointer-events: none;
  transition: all 0.3s ease;
  background-color: transparent;
  padding: 0;
}

.input:focus ~ .floating-label,
.input:not(:placeholder-shown) ~ .floating-label {
  top: 0;
  transform: translateY(-50%);
  left: 15px;
  font-size: 12px;
  color: #2d79f3;
  font-weight: 600;
  background-color: white;
  padding: 0 8px;
  z-index: 1;
}

/* 验证码输入框（为发送按钮留出空间） */
.code-with-button {
  padding-right: 110px;
}

/* 内联发送验证码按钮 */
.send-code-btn-inline {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  color: #2d79f3;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.send-code-btn-inline:hover:not(:disabled) {
  color: #1e5fbf;
  background-color: transparent;
}

.send-code-btn-inline:disabled {
  color: #999;
  cursor: not-allowed;
  background-color: transparent;
}

/* 错误样式 */
.input-error {
  border-color: #ff4444 !important;
}

.field-error {
  color: #ff4444;
  font-size: 12px;
  margin-top: 5px;
  margin-left: 5px;
}

/* 小眼睛图标 */
.eye-icon {
  cursor: pointer;
  transition: opacity 0.2s ease;
  flex-shrink: 0;
  margin-right: 8px;
  color: #666;
}

.eye-icon:hover {
  opacity: 0.7;
  color: #2d79f3;
}

.button-submit {
  margin: 20px 0 10px 0;
  background-color: #151717;
  border: none;
  color: white;
  font-size: 15px;
  font-weight: 500;
  border-radius: 10px;
  height: 50px;
  width: 100%;
  cursor: pointer;
  transition: 0.3s ease;
}

.button-submit:hover {
  background-color: #252727;
}

.button-submit:disabled {
  background-color: #666;
  cursor: not-allowed;
}

.p {
  text-align: center;
  color: black;
  font-size: 14px;
  margin: 5px 0;
}

.span {
  font-size: 14px;
  color: #2d79f3;
  font-weight: 500;
  cursor: pointer;
}

.span:hover {
  text-decoration: underline;
}
</style>
